"use strict";


// Listen for messages from the Didomi Web SDK
window.addEventListener("message", function (event) {
    try {
        var data = typeof event.data === "string" && event.data !== 'bcEmpty' ? JSON.parse(event.data) : event.data;
        if (data && data.__cmpReturn) {
            // data.__cmpReturn contains the response from the CMP
            if (data.__cmpReturn.callId === "get-user-status") {
                // This is the response to our call for getting the user status
                // The status is in data.__cmpReturn.returnValue
                var userStatus = data.__cmpReturn.returnValue;
                let enabledObj = Object.assign({},...userStatus.purposes.consent.enabled.map(key => ({[key]: ""})));

                if (jQuery('[data-vimeo_id]').length && "cookies" in enabledObj) {
                    jQuery('[data-vimeo_id]').attr('data-vimeo_dnt', '0');
                }

                // Get the iframe elements
                document.querySelectorAll('iframe').forEach(iframe => {
                    if (iframe.src.includes("vimeo")) {
                        // Get the current source URL of the iframe
                        var src = iframe.src;
                        // Check if the user has given consent for a specific purpose
                        if ("cookies" in enabledObj) {
                            // The user has given consent for cookies
                            // Append a querystring parameter to the iframe source URL
                            src = src.replace("dnt=1", "dnt=0");
                            
                        } else {
                            // The user has not given consent for cookies
                        }
                        // Update the iframe source URL
                        iframe.src = src;
                    }
                });
                
            }
        }
    } catch (e) {
        // Handle errors
        console.error(e);
    }
});

// Send a message to the Didomi Web SDK to get the user status
window.parent.postMessage({
    __cmpCall: 
    {
        command: "getUserStatus", 
        parameter: [], 
        callId: "get-user-status"
    }
}, "*");